const STORAGE_KEY = 'offline_mutation_queue_v1';
const FAILED_KEY = 'offline_mutation_failed_v1';

function safeJsonParse(value, fallback) {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

// Queued changes belong to the user who made them, so a different user on the
// same device never sends them under their own login.
export function currentUserId() {
  const user = safeJsonParse(localStorage.getItem('user') || 'null', null);
  return user?.id ?? null;
}

export function enqueueOfflineMutation(item) {
  const queue = safeJsonParse(localStorage.getItem(STORAGE_KEY) || '[]', []);
  queue.push({
    id: `${Date.now()}_${Math.random().toString(16).slice(2)}`,
    createdAt: Date.now(),
    userId: currentUserId(),
    ...item,
  });
  localStorage.setItem(STORAGE_KEY, JSON.stringify(queue));
  return queue.filter((q) => q.userId === currentUserId()).length;
}

export function peekOfflineQueue() {
  return safeJsonParse(localStorage.getItem(STORAGE_KEY) || '[]', []);
}

export function replaceOfflineQueue(nextQueue) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(nextQueue || []));
}

// Changes the server rejected (validation/permission) are kept here instead of blocking the queue.
export function recordFailedOfflineMutation(item, status, errorMessage) {
  const failed = safeJsonParse(localStorage.getItem(FAILED_KEY) || '[]', []);
  failed.push({ ...item, failedAt: Date.now(), status, error: errorMessage });
  localStorage.setItem(FAILED_KEY, JSON.stringify(failed.slice(-50)));
}
